const lineHeight = ({ $lineHeight }) => {
  if ($lineHeight) return `line-height: ${$lineHeight};`;
  return ``;
};

export default lineHeight;
